module.exports = function getResource(label, vars = []) {
    const resources = { new: 'NOUVEAUTÉ' };

    return resources[label];
};
